import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import axiosInstance from '../../api/axiosConfig';
import { Link } from 'react-router-dom';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/courses');
      const data = response.data.data || response.data;

      // Map API response to UI-friendly format
      const mappedCourses = (Array.isArray(data) ? data : []).map(course => ({
        id: course.courseId,
        name: course.courseName,
        description: "Professional certification program with practical training and expert guidance.",
        duration: `${course.durationMonths} Months`,
        level: "Industry Level",
        price: "Contact for Fees",
        highlights: [
          "Government recognized curriculum",
          "Practical lab training",
          "Expert faculty guidance",
          "Certification after completion"
        ]
      }));

      setCourses(mappedCourses);
      setError(null);
    } catch (err) {
      console.error('Error fetching courses:', err);
      setError("Unable to load courses at the moment.");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold' }}>
          Our Courses
        </Typography>
        <Typography variant="h6" sx={{ color: '#666', mb: 4 }}>
          Choose from our comprehensive range of industry-relevant courses
        </Typography>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Grid container spacing={3}>
        {courses.map((course) => (

          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: 2,
                borderRadius: 3,
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-6px)',
                  transition: 'all 0.3s ease-in-out',
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
                  {course.name}
                </Typography>

                <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
                  {course.description}
                </Typography>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                    Duration: {course.duration}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                    Level: {course.level}
                  </Typography>
                  <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 2 }}>
                    {course.price}
                  </Typography>
                </Box>

                <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold', mb: 1 }}>
                  Highlights:
                </Typography>
                <Typography component="div" variant="caption">
                  {course.highlights.map((highlight, index) => (
                    <div key={index}>✓ {highlight}</div>
                  ))}
                </Typography>
              </CardContent>

              <Box sx={{ p: 2, pt: 0 }}>
                {/* <Button
                  variant="contained"
                  fullWidth
                  href={`https://wa.me/917979966901?text=I want to enroll in ${course.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Enroll Now
                </Button> */}
                <Button
  variant="contained"
  component={Link}
  to={`/apply/${course.id}`}
>
  Apply Online
</Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* WHY CHOOSE US */}
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center' }}>
          Why Choose Our Courses?
        </Typography>
        <Grid container spacing={3}>
          {[
            { title: 'Industry Expert Instructors', desc: 'Learn from professionals with real industry experience' },
            { title: 'Practical Approach', desc: 'Hands-on projects and real-world applications' },
            { title: 'Certification', desc: 'Recognized certificates upon completion' },
            { title: 'Placement Support', desc: 'Strong placement assistance and career guidance' },
            { title: 'Flexible Schedule', desc: 'Online & offline learning options available' },
            { title: 'Lifetime Access', desc: 'Access learning material anytime' },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2">{item.desc}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Courses;
